import {
    SIMPLE_STORAGE_LOADING,
    SIMPLE_STORAGE_ERROR,
    SIMPLE_STORAGE_IMAGES_FETCH,
    SIMPLE_STORAGE_IMAGES_ADD,
    SIMPLE_STORAGE_IMAGES_DELETE,
    SIMPLE_STORAGE_VIDEOS_FETCH,
    SIMPLE_STORAGE_VIDEOS_ADD,
    SIMPLE_STORAGE_VIDEOS_DELETE
} from '../../types';

export default (state, action) => {
    switch (action.type) {
        case SIMPLE_STORAGE_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case SIMPLE_STORAGE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case SIMPLE_STORAGE_IMAGES_FETCH:
            return {
                ...state,
                images: action.payload,
                loading: false,
                error: null
            };

        case SIMPLE_STORAGE_IMAGES_ADD:
        case SIMPLE_STORAGE_IMAGES_DELETE:
            return {
                ...state,
                loading: false,
                error: null
            };

        case SIMPLE_STORAGE_VIDEOS_FETCH:
            return {
                ...state,
                videos: action.payload,
                loading: false,
                error: null
            };

        case SIMPLE_STORAGE_VIDEOS_ADD:
        case SIMPLE_STORAGE_VIDEOS_DELETE:
            return {
                ...state,
                loading: false,
                error: null
            };

        default:
            return state;
    }
};
